<script>
import options from './NykAlert.options'
export default options
</script>

<template>
    <div class="nyk-alert" 
        aria-live="polite"         
        role="status"
        aria-atomic="true"
        tabindex="-1"
        :class="{
            'nyk-alert--success': type === 'success',
            'nyk-alert--error': type === 'error',
        }">
        <slot></slot>

        <svg v-if="type === 'success'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0C4.47688 0 0 4.47688 0 10C0 15.5231 4.47688 20 10 20C15.5231 20 20 15.5231 20 10C19.9837 4.48375 15.5163 0.01625 10 0ZM14.8169 7.31687L8.56687 13.5669C8.445 13.6888 8.285 13.75 8.125 13.75C7.965 13.75 7.805 13.6888 7.68313 13.5669L5.18313 11.0669C4.93875 10.8225 4.93875 10.4275 5.18313 10.1831C5.4275 9.93875 5.8225 9.93875 6.06687 10.1831L8.125 12.2413L13.9331 6.43313C14.1775 6.18875 14.5725 6.18875 14.8169 6.43313C15.0613 6.6775 15.0613 7.0725 14.8169 7.31687Z" fill="#07094A"/>
        </svg>

        <svg v-if="type === 'error'" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_13778_11529)">
            <path d="M10 0C4.48625 0 0 4.48625 0 10C0 15.5138 4.48625 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48625 15.5138 0 10 0ZM9.0675 4.0625C9.0675 3.89 9.2075 3.75 9.38 3.75H10.62C10.7925 3.75 10.9325 3.89 10.9325 4.0625V11.5625C10.9325 11.735 10.7925 11.875 10.62 11.875H9.38C9.2075 11.875 9.0675 11.735 9.0675 11.5625V4.0625ZM10 16.25C9.30938 16.25 8.75 15.6906 8.75 15C8.75 14.3094 9.30938 13.75 10 13.75C10.6906 13.75 11.25 14.3094 11.25 15C11.25 15.6906 10.6906 16.25 10 16.25Z" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0_13778_11529">
            <rect width="20" height="20" fill="white"/>
            </clipPath>
            </defs>
        </svg>
    </div>
</template>
